module.exports = __webpack_public_path__ + "media/images/cplook/favicon-32x32-111d7f78778cadc493dac7a8f689dfd4.png";